export default "__VITE_ASSET__D4tgjoX$__"